<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <el-col :md="6" :lg="8">
                    <el-button type="primary" icon="plus" @click="addGive">补发卡密 ({{reissue}})</el-button>
                </el-col>
                <el-col :md="10" :lg="4">
                    <el-select  v-model="params.starte_id" clearable placeholder="活动类型" @change="typesearch">
                        <el-option v-for="item in starteList" :key="item.id" :label="item.line_name" size="mini" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="6" :lg="8">
                <el-button   type="danger" icon="plus">待补发数量   {{reissue}} <span style="color: #FFFFFF">（注：尽快点击补发按钮，发送至用户）</span></el-button>
              </el-col>
            </el-row>
            <el-tabs type="border-card" v-model="activeName">

                <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                    <el-table-column prop="id" width="60" label="编号"></el-table-column>
                    <el-table-column prop="serial" label="流水号"></el-table-column>
                    <el-table-column prop="line_name" label="策略名称"></el-table-column>
                    <el-table-column prop="line_many" label="赠送金额"></el-table-column>
                    <el-table-column prop="mobile" label="手机号"></el-table-column>
                    <el-table-column prop="item_title" label="商品名称"></el-table-column>
                    <el-table-column prop="username" label="昵称"></el-table-column>
                    <el-table-column prop="card" label="发送状态">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" v-if="scope.row.card.slice(0,3)=='NXX'">待补发</el-button>
                            <el-button type="success" size="mini" v-else>已发送</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="total_count > params.pageSize" class="content-padded content-center">
                    <el-pagination
                            layout="prev, pager, next"
                            @current-change="handleCurrentChange"
                            :current-page.sync="params.page"
                            :total='total_count' :page-size="params.pageSize">
                    </el-pagination>
                </div>
            </el-tabs>
        </div>
        <router-view></router-view>



    </div>
</template>
<script>
import {getGiveLogs,saveGiveLogs} from '../../../../api/promotions'

  export default {
    data() {
      return {
        loading: false,
        activeName: 'all',
        params: {
          page: 1,
          pageSize: 20
        },
        goodsList:[],
        starteList:[],
        total_count: 0,
        reissue:0,
        list: [],
      }
    },
    methods: {

      handleCurrentChange(val) {
        this.params.page = val
        this.loading = false
        this.getGiveLists()
      },



      getGiveLogs() {
        this.loading = true
        getGiveLogs(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
          this.starteList = res.data.data.starte
          this.reissue = res.data.data.reissue
        })
      },
      typesearch() {

        this.getGiveLogs()
      },
      addGive() {
        saveGiveLogs().then(res => {
            if (res.data.status) {
               this.$message({
                   message: '操作成功',
                   type: 'success',
                   duration: 2 * 1000
               })
               this.getGiveLogs()
           }
       })
      },
      // 商品
      handleGoodsDialogCancel(){
          this.goodsDialog.goodsVisible = false
      },
      handleGoodsDialogCurrentChange (page_num) {
          this.params.page = page_num
      },
      handleGoodsDialogSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
      },



    },
    mounted() {
      this.getGiveLogs()
    }
  }
</script>



// WEBPACK FOOTER //
// logs.vue?baff2270